export default "__VITE_ASSET__CCj7IxeW__"